//@flow
import * as React from 'react';

export const IncrementalPjpContext: React$Context<{
    config:
        | {
              forceReplan: boolean,
              newOutletsSelection: boolean,
              newRidersSelection: boolean,
              oldOutletsSelection: boolean,
              oldRidersSelection: boolean
          }
        | {},
    incrementalPlanType: ?$Values<{
        RETAIN_ALL_BEATS: string,
        RETAIN_NO_BEATS: string,
        RETAIN_SOME_BEATS: string
    }>,
    onOutletsNext: ({
        existingSelectedRows: Array<string>,
        newSelectedRows: Array<string>
    }) => void,
    onRidersNext: ({
        existingSelectedRows: Array<string>,
        newSelectedRows: Array<string>
    }) => void,
    onPlanCreate: () => void,
    ...
}> = React.createContext({});

export default IncrementalPjpContext.Provider;
